import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cph_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export function getVisitorId() {
  let vid = localStorage.getItem("cph_vid");
  if (!vid) {
    vid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem("cph_vid", vid);
  }
  return vid;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function uploadPublicFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/public-upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function uploadDocument(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/document-upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
